import React from 'react'

const Grid = ({ children, testId = null }) => (
  <div className="cookunity__form_grid" data-test-id={testId}>
    {children}
  </div>
)

export default Grid
